import React, { useState } from 'react';
import {
  Box, Paper, Typography, TextField, Button, Grid, Divider,
  Avatar, Card, CircularProgress,
} from '@mui/material';
import { toast } from 'react-toastify';
import { profileAPI } from '../services/api';
import { useAuth } from '../services/AuthContext';

export default function Profile() {
  const { user, updateUser } = useAuth();
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({
    full_name: user?.full_name || '',
    phone: user?.phone || '',
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await profileAPI.updateProfile(form);
      updateUser(res.data);
      toast.success('Profile updated successfully');
      setEditing(false);
    } catch {
      toast.error('Failed to update profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>My Profile</Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ textAlign: 'center', p: 3 }}>
            <Avatar sx={{ width: 100, height: 100, mx: 'auto', mb: 2, bgcolor: 'primary.main', fontSize: 40 }}>
              {user?.full_name?.charAt(0)?.toUpperCase()}
            </Avatar>
            <Typography variant="h6" fontWeight="bold">{user?.full_name}</Typography>
            <Typography variant="body2" color="text.secondary">{user?.email}</Typography>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body2" color="text.secondary">
              Member since {new Date(user?.date_joined).toLocaleDateString()}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6" fontWeight="bold">Profile Information</Typography>
              <Button variant={editing ? 'outlined' : 'contained'}
                onClick={() => editing ? handleSave() : setEditing(true)}
                disabled={saving}>
                {saving ? <CircularProgress size={20} /> : editing ? 'Save Changes' : 'Edit Profile'}
              </Button>
            </Box>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Full Name" name="full_name"
                  value={form.full_name} onChange={handleChange}
                  disabled={!editing} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Email" value={user?.email || ''} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Phone" name="phone"
                  value={form.phone} onChange={handleChange} disabled={!editing} />
              </Grid>
            </Grid>

            {editing && (
              <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                <Button variant="outlined" color="error" onClick={() => setEditing(false)}>Cancel</Button>
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
